__webpack_require__.p = "/story/assets/";